<template>
  <div>
    <Modal
      title="Edit Memberships"
      :saving="saving"
      submit-btn-text="Save & Complete"
      @hide-modal="$emit('hide-modal')"
      @submit="handleSave"
    >
      <div class="d-flex align-items-center">
        <b class="modal-label">{{ customer.full_name }}</b>
        <img
          v-if="membership"
          class="ml-1 membership-icon"
          :src="membership.icon_url"
        />
      </div>
      <div class="divider"></div>
      <div>
        <div class="modal-label mb-1"><b>Active</b></div>
        <ActiveMembershipDetails
          v-if="membership"
          v-model="cancelDate"
          :membership="membership"
        />
        <div
          v-else
          class="no-membership d-flex align-items-center justify-content-center flex-column"
        >
          <i class="fas fa-heart-broken"></i>
          Not a Member
        </div>
      </div>
      <div class="divider"></div>
      <div class="label"><b>Sold</b></div>
      <CustomerMembershipForm ref="form" :membership="soldMembership" />
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import Modal from "@/components/Modal.vue";
import ActiveMembershipDetails from "./ActiveMembershipDetails.vue";
import CustomerMembershipForm from "./CustomerMembershipForm.vue";

export default {
  components: {
    Modal,
    CustomerMembershipForm,
    ActiveMembershipDetails
  },
  props: {
    customer: {
      type: Object,
      default: () => {}
    },
    membership: {
      type: Object,
      default: null
    },
    soldMembership: {
      type: Object,
      default: null
    },
    workItemId: {
      type: Number,
      default: null
    }
  },
  emits: ["hide-modal", "save-success"],
  data() {
    return {
      saving: false,
      cancelDate: ""
    };
  },
  mounted() {
    this.fetchMembershipPrograms();
    if (this.membership) {
      this.cancelDate = this.membership.ends_at;
    }
  },
  methods: {
    ...mapActions([
      "fetchMembershipPrograms",
      "createCustomerMembership",
      "fetchMembershipChanges",
      "confirmDelete"
    ]),
    createMembership(payload) {
      this.createCustomerMembership(payload)
        .then(() => {
          this.$emit("save-success");
          window.notify.success("Membership updated successfully!");
          this.$emit("hide-modal");
        })
        .finally(() => (this.saving = false));
    },
    getPayload(formData) {
      const payload = {
        membership: formData
      };
      if (this.cancelDate) {
        payload.replaces_membership = {
          membership_id: this.membership.membership_id,
          ends_at: this.cancelDate
        };
      }
      if (this.workItemId) {
        payload.workflow_item_id = this.workItemId;
      }
      return {
        customerId: this.customer.customer_id,
        data: payload
      };
    },
    handleSave() {
      this.$refs.form.getFormData().then((formData) => {
        this.saving = true;
        const payload = this.getPayload(formData);
        this.fetchMembershipChanges(payload)
          .then((res) => {
            if (res.data.message) {
              this.confirmDelete({
                message: res.data.message,
                title: "Confirm Changes"
              })
                .then(() => {
                  this.createMembership(payload);
                })
                .catch(() => (this.saving = false));
            } else {
              this.createMembership(payload);
            }
          })
          .catch(() => (this.saving = false));
      });
    },
    onDelete() {
      this.toggleConfirm();
    },
    toggleConfirm() {
      this.confirm = !this.confirm;
    }
  }
};
</script>

<style lang="scss" scoped>
.divider {
  width: 100%;
  border-top: 1px solid var(--gray-border-color);
  margin: 15px 0;
}
.membership-icon {
  height: 1.9em;
}
.no-membership {
  font-size: 0.9rem;
  color: var(--gray);
  margin-top: -15px;
}
.modal-label {
  font-size: 1rem;
}
</style>
